import * as urls from "../../api/C4S Decommission - Replacement/url";
import { getRequest } from "../../../services/RestServices";

export const getWorkTicketVINList = async (workTicketId) => {
  try {
    return await getRequest(urls.GET_WORKTICKET_VIN_LIST + `/${workTicketId}`);
  } catch (err) {
    return err;
  }
};

export const getWorkticketVehiclesAndAssetsList = async (workTicketId) => {
  try {
    return await getRequest(urls.GET_VEHICLES_AND_ASSETS_LIST + `/${workTicketId}/vehiclesAndAssets`);
  } catch (err) {
    return err;
  }
};

export const getWorkticketVehiclesHistoryList = async (workTicketId) => {
  try {
    return await getRequest(urls.GET_VEHICLES_HISTORY_LIST + `?workTicketId=${workTicketId}`);
  } catch (err) {
    return err;
  }
};
